import { dynamicString } from '@home/utils/dynamicString';
import { stringToFunction } from '@/pages/dashboard/utils/stringToJson';

type TDynamicStringData = Record<string, any>;

export const resolveBySegmentType = (
  value: unknown,
  segmentType = '',
  data?: TDynamicStringData,
  fallback = '',
): string => {
  if (typeof value !== 'string' && typeof value !== 'function') {
    return fallback;
  }

  try {
    const parsedValue = typeof value === 'function'
      ? value
      : stringToFunction(value);
    const resolvedValue = typeof parsedValue === 'function'
      ? parsedValue(segmentType)
      : parsedValue;

    if (typeof resolvedValue !== 'string') {
      return fallback;
    }

    return dynamicString(resolvedValue, data, fallback);
  } catch (error) {
    return fallback;
  }
};